import Tooltip from '@mui/material/Tooltip';
import { NavDropdown } from 'react-bootstrap';
import Iconify from 'src/components/Iconify';
import { roleType } from 'src/Helpers/constant';

export default function NavbarHtmlContent({ setActionState, actionState, menuType, renderType }) {
  return (
    <div className="heading-wrapper justify-content-end">
      <div className="d-flex justify-content-end align-items-center">
        {renderType?.type === roleType.AUTHOR || (renderType?.type === roleType.INSTRUCTOR && menuType === 'CUSTOM') ? (
          <NavDropdown className="action-dropdown" id="basic-nav-dropdown">
            {renderType?.write && (
              <NavDropdown.Item className="d-flex justify-content-between align-items-center">
                <div
                  style={{ cursor: 'pointer' }}
                  onClick={() =>
                    setActionState({
                      ...actionState,
                      add: true,
                    })
                  }
                >
                  <Iconify className="text-success user-btn" icon={'eva:plus-fill'} />
                  <span className="ms-2">Add</span>
                </div>
                {actionState.add && (
                  <Tooltip title="Add Reset" placement="top-start">
                    <span>
                      <Iconify
                        style={{ cursor: 'pointer' }}
                        className="text-success user-btn"
                        icon={'eva:refresh-fill'}
                        onClick={() =>
                          setActionState({
                            ...actionState,
                            add: false,
                          })
                        }
                      />
                    </span>
                  </Tooltip>
                )}
              </NavDropdown.Item>
            )}

            {renderType?.edit && (
              <NavDropdown.Item className="d-flex justify-content-between align-items-center">
                <div
                  style={{ cursor: 'pointer' }}
                  onClick={() =>
                    setActionState({
                      ...actionState,
                      edit: true,
                    })
                  }
                >
                  <Iconify className="text-primary user-btn" icon={'eva:edit-fill'} />
                  <span className="ms-2">Edit</span>
                </div>
                {actionState.edit && (
                  <Tooltip title="Edit Reset" placement="top-start">
                    <span>
                      <Iconify
                        style={{ cursor: 'pointer' }}
                        className="text-primary user-btn"
                        icon={'eva:refresh-fill'}
                        onClick={() =>
                          setActionState({
                            ...actionState,
                            edit: false,
                          })
                        }
                      />
                    </span>
                  </Tooltip>
                )}
              </NavDropdown.Item>
            )}

            {renderType?.edit && (
              <NavDropdown.Item className="d-flex justify-content-between align-items-center">
                <div
                  style={{ cursor: 'pointer' }}
                  onClick={() =>
                    setActionState({
                      ...actionState,
                      delete: true,
                    })
                  }
                >
                  <Iconify className="text-danger user-btn" icon={'eva:trash-fill'} />
                  <span className="ms-2">Delete</span>
                </div>
                {actionState.delete && (
                  <Tooltip title="Delete Reset" placement="top-start">
                    <span>
                      <Iconify
                        style={{ cursor: 'pointer' }}
                        className="text-danger user-btn"
                        icon={'eva:refresh-fill'}
                        onClick={() =>
                          setActionState({
                            ...actionState,
                            delete: false,
                          })
                        }
                      />
                    </span>
                  </Tooltip>
                )}
              </NavDropdown.Item>
            )}
          </NavDropdown>
        ) : (
          ''
        )}
      </div>
    </div>
  );
}
